import type {
  ApplyInitiativesSearchCriteriaAction,
  ClearInitiativesSearchCriteriaAction,
} from "domains/initiatives/actionTypes";
import { TopicInitiativeType } from "domains/initiatives/actionTypes";

export const applyInitiativesSearchCriteria = (
  payload: ApplyInitiativesSearchCriteriaAction["payload"],
): ApplyInitiativesSearchCriteriaAction => ({
  type: TopicInitiativeType.APPLY_SEARCH_CRITERIA,
  payload,
});

export const clearInitiativesSearchCriteria = (): ClearInitiativesSearchCriteriaAction => ({
  type: TopicInitiativeType.CLEAR_SEARCH_CRITERIA,
});
